import { Fragment, useContext } from 'react';

import { TYPE_LABELS } from '@atom/components/common/requests/assetRequestConstants';
import { useViewerUserGroupIds } from '@atom/components/common/requests/useViewerUserGroupIds';
import { useUserProfile } from '@atom/hooks/useUserProfile';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { getDisplayDateTime } from '@atom/utilities/timeUtilities';
import { getUserFullName } from '@atom/utilities/userUtilities';

import ViewRequestContext from '../ViewRequestContext';

import ADOTApprovalControls from './ADOTApprovalControls';
import ADOTApprovalDisplay from './ADOTApprovalDisplay';
import ADOTAssignedGroup from './ADOTAssignedGroup';

import classes from './adotView.module.css';

const ADOTTransferView = () => {
  const { activeRequest } = useContext(ViewRequestContext);
  const userProfile = useUserProfile();

  const isPending = activeRequest?.status === AssetRequestStatus.PENDING;

  const { userGroupIds, loading: viewerLoading } =
    useViewerUserGroupIds(isPending);

  const viewer = { userId: userProfile?.userId, userGroupIds };

  const assignees = [
    ...(activeRequest?.assignedTo || []).map(user => ({
      key: user.id,
      content: getUserFullName(user),
    })),
    ...(activeRequest?.assignedToGroups || []).map(group => ({
      key: group.id,
      content: <ADOTAssignedGroup group={group} />,
    })),
  ];

  const createdByText = `Created by ${getUserFullName(
    activeRequest?.createdBy,
  )} on ${getDisplayDateTime(activeRequest?.createdDate)}`;

  return (
    <div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Request Type</div>
        <div>{TYPE_LABELS[activeRequest?.type]}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Transfer From</div>
        <div>{activeRequest?.fromAssetName || ''}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Transfer To</div>
        <div>{activeRequest?.assetName || ''}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>{`Requested Quantity (${
          activeRequest?.assetUnit || ''
        })`}</div>
        <div>{activeRequest?.quantityOrdered}</div>
      </div>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Assigned To</div>
        <div data-cy="adotTransferAssignedTo">
          {assignees.map((assignee, index) => (
            <Fragment key={assignee.key}>
              {assignee.content}
              {index < assignees.length - 1 && ', '}
            </Fragment>
          ))}
        </div>
      </div>
      <div className={classes.createdSubtext}>{createdByText}</div>
      {isPending ? (
        <ADOTApprovalControls viewer={viewer} viewerLoading={viewerLoading} />
      ) : (
        <ADOTApprovalDisplay />
      )}
    </div>
  );
};

export default ADOTTransferView;
